module.exports = __webpack_public_path__ + "static/media/mariya-georgieva.4575c40b.jpg";